import 'stylesheets/components/page.scss';
import 'stylesheets/global.scss';

import React from 'react';
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {bindActionCreators} from 'redux';
import {injectIntl} from 'react-intl';
import moment from 'moment';
import {requestActionsFor} from 'app/lib/actionCreatorsFor';
import {serverToDisplayTimeSlot, serverDateFormat, displayDateFormat, displayToServerDate} from 'app/lib/format';
import {getTerminals, isAllowed} from 'modules/profile/selectors';
import {getReports} from 'modules/reports/selectors';
import {isAuthenticated} from "../../../modules/auth/selectors";
import Dashboard from '../components/Dashboard';

export class DashboardPage extends React.Component {

    render() {
        return (
            <Dashboard {...this.props} />
        );
    }

}

function mapStateToProps(state) {
    const terminals = getTerminals(state);
    return {
        terminals,
        reports: getReports(state),
        isAllowed: isAllowed(state),
        isAuthenticated: isAuthenticated(state),
        initialValues: {
            dom: terminals.length> 0 ? terminals[0].code : null,
            date: moment().format(displayDateFormat),
            dayOfWeek: moment().isoWeekday()+''
        }
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            getActualTrucks: requestActionsFor('actual_trucks').request,
            getActualLeadTime: requestActionsFor('actual_lead_time').request,
            getActualOccupancy: requestActionsFor('actual_occupancy').request,
            getAverageLeadTime: requestActionsFor('average_lead_time').request,
            getRailStatusImport: requestActionsFor('rail_status_import').request,
            getRailStatusExport: requestActionsFor('rail_status_export').request
        }, dispatch)
    };
}

export const DashboardContainer = reduxForm({
    form: 'dashboard',
    fields: ['dom', 'date', 'dayOfWeek'],
    getFormState: (state, reduxMountPoint) => state.get(reduxMountPoint).toJS()
}, mapStateToProps, mapDispatchToProps)(injectIntl(DashboardPage));
